import React from 'react';
import classNames from 'classnames';

import {useMediaQuery} from 'src/hooks/useMediaQuery';

import Button from 'src/components/button';
import SchoolHeader from './school-header';
import styles from './empty-institution-section.module.scss';

interface Props {
  name: string;
  classYear: string;
  onAddClick: () => void;
}

const EmptyInstitutionSection = ({name, classYear, onAddClick}: Props) => {
  const mq = useMediaQuery();

  return (
    <div className={styles.addSection}>
      <SchoolHeader className={styles.name}>{name}</SchoolHeader>
      Add courses from your {classYear} year and earn up to $1,000 for every completed course
      <Button
        outline
        className={classNames('mt-20', styles.button)}
        onClick={onAddClick}
        {...(mq.SM_AND_DOWN && {size: 'small', width: '100%'})}
      >
        + Add Course
      </Button>
    </div>
  );
};

export default EmptyInstitutionSection;
